import { createPaymentIntent, getDiscount } from "./api";
import { getFeatured, getProductsByCategory, getOrder } from "./api";

export const getValidName=(name)=>{
    return name.toLowerCase().replace("&", "n");
}

export const fetchData = async(item, payload)=>{
    switch (item) {
        case "products":
            return await getProductsByCategory(payload.category);
        case "featured":
            return await getFeatured();
        case "order":
            return await getOrder(payload.id);
        case "paymentIntent":
            return await createPaymentIntent(payload.cartData);
        case "discount":
            return await getDiscount(payload.code);
        default:
            return [];
    }
}

export const getProductImage=(item)=>{
    if(Object.hasOwn(item, "images")){
      return item.images[0];
    }
    return "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png";
}